import { CareerGoal } from '@map/types';
import { Reducer } from 'redux';

const initialState = {} as Record<string, CareerGoal>;
type State = typeof initialState;

const CAREER_GOALS_FETCHED = 'CAREER_GOALS_FETCHED';

export const actionCreators = {
  careerGoalsFetched: (data: State) => ({ type: CAREER_GOALS_FETCHED, data }) as const,
};

type Action = ReturnType<(typeof actionCreators)[keyof typeof actionCreators]>;

const careerGoals: Reducer<State, Action> = (state = initialState, action) => {
  switch (action.type) {
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    case CAREER_GOALS_FETCHED:
      return action.data;
    default:
      return state;
  }
};

export default careerGoals;
